import { OrderItem } from '../../types';
import { orderItem } from '../order_item/validate';
import { arrayOf, test } from '../validate';


export const orderItems = test((orderItems: OrderItem[]) => {
    return {
        items: arrayOf(orderItems, orderItem),
    }
})